export enum DISPLAY_ITEM_ID {
  /** 利用中キャリア */
  USING_MOBILE_CARRIER = 'ITEM00008',
  /** 利用中機種 */
  USING_MOBILE_KINDS_NAME = 'ITEM00010',
  /** モバイル更新月 */
  MOBILE_UPD_YEAR_MONTH = 'ITEM00011',
  /** 割賦残債 */
  MOBILE_INSTALL_MONTHLY_PAYMENT = 'ITEM00014',
  /** 割賦残債終了年月 */
  MOBILE_INSTALL_END_YEAR_MONTH = 'ITEM00015',
  /** お住まい */
  HOUSING_TYPE = 'ITEM00026',
  /** エリアチェック結果 */
  INFORMATION_PROVISION_STATUS = 'ITEM00027',
  /** 固定回線の状態 */
  LANDLINE_PHONE_USAGE_STATUS = 'ITEM00028',
  /** 固定回線状態（SB光） */
  FIXED_LINE_STATUS_SB_HIKARI = 'ITEM00228',
  /** 毎月のお支払い金額（SB光） */
  USING_SB_HIKARI_MONTHLY_PAYMENT = 'ITEM00235',
  /** 毎月のお支払い金額（SBAir） */
  USING_SB_AIR_MONTHLY_PAYMENT = 'ITEM00236',
  /** 毎月のお支払い金額（おうちのでんわ） */
  USING_LANDLINE_PHONE_MONTHLY_PAYMENT = 'ITEM00237',
  /** 下取り有無 */
  USING_TRADE_IN_FLG = 'ITEM00238',
  /** 毎月のデータ通信容量 */
  USING_DATA_TRAFFIC = 'ITEM00239',
  /** 毎月の電子決済金額 */
  ELECTRONIC_PAYMENT = 'ITEM00242',
  /** クレジットカードご利用状況 */
  USING_MOBILE_CREDIT_CARD = 'ITEM00243',
  /** 使用者予定 */
  USER_PLAN = 'ITEM00240',
  /** 利用中のネット環境 */
  USING_HOME_INTERNET_TYPE = 'ITEM00029',
  /** NTT116確認結果 */
  INTERNETLINE_CONTRACT_HOLDER = 'ITEM00031',
  /** 契約中回線事業者 */
  USING_INTERNETLINE_PROVIDER = 'ITEM00032',
  /** 契約中回線事業者備考欄 */
  USING_INTERNETLINE_PROVIDER_REMARKS = 'ITEM00033',
  /** 契約中プロバイダ */
  USING_LANDLINE_PHONE_PROVIDER = 'ITEM00034',
  /** 契約中プロバイダ備考欄 */
  USING_LANDLINE_PHONE_PROVIDER_REMARKS = 'ITEM00035',
  /** 契約更新月（インターネット・固定電話） */
  USING_INTERNETLINE_UPD_YEAR_MONTH = 'ITEM00036',
  /** 現在の電力事業者 */
  USING_PWR_PROVIDER = 'ITEM00045',
  /** 現在の電力事業者（その他） */
  USING_PWR_PROVIDER_NAME = 'ITEM00046',
  /** 電気料金月 */
  USING_PWR_MONTH = 'ITEM00047',
  /** 電気料金金額 */
  USING_PWR_MONTH_CHARGE = 'ITEM00048',
  /** お住まい（おうちでんき） */
  USING_PWR_HOUSING_TYPE = 'ITEM00049',
  /** 契約形態（モバイル） */
  CONTRACT_TYPE_MOBILE = 'ITEM00054',
  /** 契約形態（SB光） */
  CONTRACT_TYPE_HIKARI = 'ITEM00055',
  /** 契約形態（Air） */
  CONTRACT_TYPE_AIR = 'ITEM00056',
  /** 契約形態（おうちのでんわ） */
  CONTRACT_TYPE_HOME = 'ITEM00060',
  /** 契約形態（おうちでんき） */
  CONTRACT_TYPE_PWR = 'ITEM00061',
  /** 割賦残債（1-24回） */
  USING_MOBILE_INSTALL_MONTHLY_PAYMENT_EARLY = 'ITEM00062',
  /** 特典利用開始日 */
  CAMPAIGN_START_MONTH = 'ITEM00063',
  /** 残債金額 */
  MOBILE_BALANCE = 'ITEM00075',
  /** 加入特典 */
  SUBSCRIPTION_BENEFITS = 'ITEM00076',
  /** 光セット */
  HIKARI_SET = 'ITEM00078',
  /** でんきセット */
  DENKI_SET = 'ITEM00079',
  /** スマートログイン設定 */
  SMART_LOGIN_SETTING = 'ITEM00080',
  /** MSN設定 */
  MSN_SETTING = 'ITEM00081',
  /** 契約確率 */
  CONTRACT_ACCURACY_TYPE = 'ITEM00082',
  /** メールアドレス */
  CUSTOMER_EMAIL_SUFFIX = 'ITEM00084',
  /** 家族構成 */
  FAMILY_INFORMATION = 'ITEM00085',
  /** メール送信先 */
  DESTINATION_TYPE = 'ITEM00086',
  /** 本人確認書類 */
  IDENTITY_VERIFICATION_DOCUMENT_TYPE = 'ITEM00087',
  /** 臨時コード① */
  TEMP_CD1 = 'ITEM00104',
  /** 見込理由 */
  REGISTER_REASON_TYPE = 'ITEM00112',
  /** 見込理由（その他メモ） */
  REGISTER_REASON_TYPE_CONTENTS = 'ITEM00113',
  /** 在留期限年 */
  STAY_DEADLINE = 'ITEM00139',
  /** アクション予定時間FROM */
  ACTION_TIME_FROM_HOUR = 'ITEM00140',
  /** アクション予定時間TO */
  ACTION_TIME_TO_HOUR = 'ITEM00141',
  /** アクション予定時間FROM_架電 */
  ACTION_TIME_FROM_HOUR_K = 'ITEM00223',
  /** アクション予定時間TO_架電 */
  ACTION_TIME_TO_HOUR_K = 'ITEM00224',
  /** アクション完了時間 */
  ACTION_COMPLETE_TIME_HOUR = 'ITEM00142',
  /** アクション予定分FROM */
  ACTION_TIME_FROM_MINUTE = 'ITEM00143',
  /** アクション予定分TO */
  ACTION_TIME_TO_MINUTE = 'ITEM00144',
  /** アクション完了分 */
  ACTION_COMPLETE_TIME_MINUTE = 'ITEM00145',
  /** アクション対応結果 */
  ACTION_STATUS_TYPE = 'ITEM00146',
  /** その他追加書類 */
  OTHER_VERIFICATION_DOCUMENT_TYPE = 'ITEM00148',
  /** 商談ステータス */
  NEGOTIATION_PROGRESS_TYPE = 'ITEM00149',
  /** 契約予定名義 */
  CONTRACTOR_TYPE = 'ITEM00150',
  /** 支払終了月（1-24回） */
  USING_MOBILE_INSTALL_END_YEAR_MONTH_EARLY = 'ITEM00151',
  /** 取り置きメモ */
  KEEP_NOTE = 'ITEM00153',
  /** 業務：契約形態（その他） */
  CONTRACT_TYPE_OTHER = 'ITEM00154',
  /** 業務（その他） */
  OTHER_PRODUCT_BUSINESS_NOTE = 'ITEM00155',
  /** 対応ステータス */
  OTHER_PRODUCT_ACTION_STATUS_TYPE = 'ITEM00156',
  /** 希望プラン（おうちでんき） */
  PWR_HOPE_PRICE_PLAN = 'ITEM00157',
  /** 希望機種有無（未決定メモ） */
  HOPE_KINDS_REMARKS = 'ITEM00158',
  /** 送信先のSB/YM電話番号 */
  SEND_SB_YM_NUMBER = 'ITEM00169',
  /** 一斉送信メール */
  SEND_BULK_MAIL = 'ITEM00170',
  /** Y!Mobileサービスの初期設定 */
  YM_SERVICE_INITIAL_SETTING = 'ITEM00171',
  /** 商材カテゴリ */
  COMMODITY_CATEGORY = 'ITEM00181',
  /** ご利用状況：利用中キャリア（その他） */
  USING_MOBILE_CARRIER_TEXT = 'ITEM00065',
  /** ご利用状況：利用中機種：機種タイプ */
  USING_MOBILE_KIND_TYPE = 'ITEM00009',
  /** ご利用状況：利用中機種：機種名 */
  USING_MOBILE_KIND_NAME = 'ITEM00010',
  /** ご利用状況：請求群 */
  USING_MOBILE_BILLING_GROUP_TYPE = 'ITEM00012',
  /** ご利用状況：毎月のお支払い金額 */
  USING_MOBILE_MONTHLY_PAYMENT = 'ITEM00013',
  /** 現在機種の利用開始年月（モバイル） */
  USING_MOBILE_START_YEAR_MONTH = 'ITEM00249',
  /** 解約金（モバイル） */
  MOBILE_CANCELLATION_FEE = 'ITEM00250',
  /** 現在回線の利用開始年月（SB光） */
  USING_SB_HIKARI_START_YEAR_MONTH = 'ITEM00251',
  /** 解約金（SB光） */
  SB_HIKARI_CANCELLATION_FEE = 'ITEM00252',
  /** 現在回線の利用開始年月（SBAir） */
  USING_SB_AIR_START_YEAR_MONTH = 'ITEM00253',
  /** 解約金（SBAir） */
  SB_AIR_CANCELLATION_FEE = 'ITEM00254',
  /** 現在回線の利用開始年月（おうちのでんわ） */
  USING_LANDLINE_PHONE_START_YEAR_MONTH = 'ITEM00255',
  /** 解約金（おうちのでんわ） */
  LANDLINE_PHONE_CANCELLATION_FEE = 'ITEM00256',
  /** 現在電力事業者の利用開始年月（おうちでんき） */
  USING_PWR_START_YEAR_MONTH = 'ITEM00257',
  /** 解約金（おうちでんき） */
  PWR_CANCELLATION_FEE = 'ITEM00258',
  /** ご希望の内容：希望機種有無 */
  HOPE_KINDS_FLG = 'ITEM00072',
  /** ご希望の内容：希望機種タイプ */
  HOPE_KINDS_TYPE = 'ITEM00152',
  /** ご希望の内容：希望機種名 */
  HOPE_KINDS_NAME = 'ITEM00002',
  /** ご希望の内容：取り置き */
  KEEP_TYPE = 'ITEM00058',
  /** ご希望の内容：料金プラン */
  PRICE_PLAN = 'ITEM00003',
  /** ご希望の内容：料金プラン(YM) */
  YM_PRICE_PLAN = 'ITEM00159',
  /** ご希望の内容：パケットサービス */
  PACKET_DSCT_SERVICE = 'ITEM00004',
  /** ご希望の内容：店頭スマホサポート */
  SMART_PHONE_SET_SUPPORT = 'ITEM00073',
  /** ご希望の内容：店頭スマホサポート(その他) */
  SMART_PHONE_SET_SUPPORT_TEXT = 'ITEM00074',
  /** PayPay設定 */
  PAYPAY_SETTING = 'ITEM00241',
  /** その他：特記事項 */
  PRODUCT_NOTICE_AGE_CHECK = 'ITEM00147',
  /** メール送信タイプ区分 */
  EMAIL_SENDING_TYPE = 'ITEM00229',
  /** 商材ブランド*/
  COMMODITY_CATEGORY_BRAND = 'ITEM00230',
  /** 割賦前半終了回数 */
  USING_MOBILE_INSTALL_EARLY_LAST_COUNT = 'ITEM00232',
  /** お客様還元金額 */
  PAY_BACK_AMOUNT = 'ITEM00246',
  /** 商談成立条件 */
  SATISFIED_CRITERIA = 'ITEM00247',
  /** 商談成立条件 その他 */
  SATISFIED_CRITERIA_TEXT = 'ITEM00248',
}

export default DISPLAY_ITEM_ID;
